
<form @submit.prevent="save">
	<b-loading :active="isProccessing"></b-loading>
	<div class="modal-card">
		<header class="modal-card-head">
			<p class="modal-card-title">Dodawanie użytkownika</p>
			<button
				type="button"
				class="delete"
				aria-label="close"
				@click="$parent.$emit('close')"
			></button>
		</header>
		<section class="modal-card-body">
			<div class="group">
				<div class="field is-horizontal field--username">
					<div class="field-label">Nazwa:</div>
					<editable
						:isEditMode="true"
						:value="user.username"
						required
						placeholder="adam_nowak"
						type="text"
						@input="user.username = $event"
					/>
				</div>
				<div class="field is-horizontal field--plainPassword">
					<div class="field-label">Hasło:</div>
					<editable
						:isEditMode="true"
						:value="user.plainPassword"
						required
						placeholder="●●●●●●●"
						type="password"
						@input="user.plainPassword = $event"
					/>
				</div>
				<hr />
				<div class="field is-horizontal field--isAdmin">
					<div class="field-label">Administrator:</div>
					<editable
						:isEditMode="true"
						:checked="user.isAdmin"
						type="switch"
						@input="user.isAdmin = $event"
					/>
				</div>
			</div>
		</section>
		<footer class="modal-card-foot">
			<button type="submit" class="button is-success button--save">
				<i class="mdi">save</i> Dodaj
			</button>
			<button
				class="button is-white button--cancel"
				type="button"
				@click="$parent.$emit('close')"
			>
				Anuluj
			</button>
		</footer>
	</div>
</form>
